// extracted by mini-css-extract-plugin
export default {"search":"SearchPage_search__GF7nt"};